import { render, staticRenderFns } from "./PreviousProcedure.vue?vue&type=template&id=7f9b03b0&"
import script from "./PreviousProcedure.vue?vue&type=script&lang=js&"
export * from "./PreviousProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports